import { render, staticRenderFns } from "./pxzt_list.vue?vue&type=template&id=2deabc93&scoped=true"
import script from "./pxzt_list.vue?vue&type=script&lang=js"
export * from "./pxzt_list.vue?vue&type=script&lang=js"
import style0 from "./pxzt_list.vue?vue&type=style&index=0&id=2deabc93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deabc93",
  null
  
)

export default component.exports